import { AssignmentViewModel } from 'api/model';
import Table from 'components/Table';
import useTranslations from 'contexts/basicData/useTranslations';
import { FC, useMemo } from 'react';
import styled from 'styled-components';
import useAssignmentsBulkOperations from '../useAssignmentsBulkOperations';
import useColumnSettings, { ColumnRenderProps } from './useColumnSettings';
// import GroupableTable from 'components/Table/GroupableTable';

const MyTable = styled(Table)`
  flex: 1;
` as typeof Table;

// const GroupHeader = styled.div`
//   font-weight: bold;
//   font-size: 1.1em;
//   padding: 0.1em;
//   background-color: #f0f0f0;
//   border-bottom: 1px solid #ccc;
//   color: #333;
//   text-align: left;
//   text-transform: uppercase;
//   letter-spacing: 0.1em;
//   margin-bottom: 0.5em;
//   border-radius: 4px;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
//   transition: background-color 0.3s ease;
//   &:hover {
//     background-color: #e0e0e0;
//   }
// `;

interface Props {
  assignments: AssignmentViewModel[];
  onAssignmentItemClick(model: AssignmentViewModel): void;
  bulkOperations: ReturnType<typeof useAssignmentsBulkOperations>;
  currentPage?: number;
  onGoToPage?(page: number): void;
  totalPageCount?: number;
  pageSize?: number;
}

const BulkApproveAssignmentsList: FC<Props> = ({
  assignments,
  onAssignmentItemClick,
  bulkOperations,
  currentPage,
  onGoToPage,
  totalPageCount,
  pageSize,
}) => {
  const translations = useTranslations();
  const columnSettings = useColumnSettings();

  const renderProps = useMemo(
    (): ColumnRenderProps => ({
      onSelectClick: (avm) => {
        bulkOperations.toggleSelectAssignment(avm.assignment.assignmentID);
      },
      selectedAssignmentIds: bulkOperations.selectedAssignmentIds,
      translations,
    }),
    [bulkOperations, translations]
  );
  const initialSortState = {
    sortedColumnIndex: 2,
    ascending: true,
  };

  // const renderGroupHeader = (groupName: string) => {
  //   return <GroupHeader>{groupName}</GroupHeader>;
  // };

  return (
    <MyTable
      // groupBy={(row) => row.assignment.assignedTo?.name ?? '-'}
      // groupHeader={renderGroupHeader}
      columnSettings={columnSettings}
      currentPage={currentPage}
      initialSortState={initialSortState}
      onGoToPage={onGoToPage}
      onRowClick={onAssignmentItemClick}
      pageSize={pageSize}
      renderProps={renderProps}
      rows={assignments}
      totalPageCount={totalPageCount}
      useColumnWidthAsFlexAmount
    />
  );
};

export default BulkApproveAssignmentsList;
